import { ComplexBase } from '@syncfusion/ej2-react-base';
export class RangeColorDirective extends ComplexBase {
}
RangeColorDirective.moduleName = 'rangeColor';
export class RangeColorsDirective extends ComplexBase {
}
RangeColorsDirective.propertyName = 'rangeColors';
RangeColorsDirective.moduleName = 'rangeColors';
